module.exports = __webpack_public_path__ + "static/7f-575ad71fc1593587a793a0d938a767b0.png";